import React from 'react';
import { Query } from '@apollo/client/react/components';

import PopularAssetSearch from 'buyside/graphql/queries/PopularAssetSearch.graphql';

import OnboardingSuggestions from 'buyside/components/presentation/Onboarding/OnboardingSuggestions/onboardingSuggestions';

const OnboardingTickerSuggestionsContainer = props => (
  <Query
    query={PopularAssetSearch}
    variables={{ categoryName: props.categoryName, categoryType: props.categoryType }}
  >
    {({ loading, refetch, error, data = {} }) => (
      <OnboardingSuggestions
        loading={loading}
        refetch={refetch}
        error={error}
        suggestions={data ? data.popularAssetSearch : null}
        {...props}
      />
    )}
  </Query>
);

export default OnboardingTickerSuggestionsContainer;
